module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1525-4f9e147e1d0f666e7821cc1e722e31bb.png";